import styled from 'styled-components';

export const StyledBagelCodeSection = styled.div`
    &.section-bagelcode {
        font-family: var(--font-family), Arial;
        display: inline-flex;
        align-items: center;
        position: relative;

        .section-bagelcode {
            &__bg-img {
                z-index: -1;
            }

            &__content {
                z-index: 1;
                position: absolute;
                top: 45%;
                left: 50%;
                transform: translate(-50%, -50%);
                display: flex;
                align-items: center;
                gap: 5px;
            }

            &__section-name {
                color: white;
                font-weight: 700;
                font-size: 16px;
                text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
                    1px 1px 0 #000;
            }

            &__prefix-image {
                height: 20px;
            }
        }
    }
` as any;
